import React from "react";
import { motion } from "framer-motion";
import { fadeUp, fadeIn } from "../lib/motion";

export const Manifesto = () => {
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden bg-[#0A0D10] border-y border-[var(--border)]" data-testid="manifesto">
      {/* clipped image frame */}
      <div className="absolute inset-0 opacity-[0.14]" aria-hidden="true">
        <img
          src="https://images.unsplash.com/photo-1598735064309-86f7f4ba875b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
          alt=""
          className="w-full h-full object-cover"
          style={{ clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0D10] via-[#0A0D10]/70 to-transparent" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-5">
        <motion.p className="eyebrow text-emerald mb-8" {...fadeUp(0, { y: 12 })}>
          This is more than a membership.
        </motion.p>

        <motion.h2
          className="font-display text-3xl sm:text-5xl lg:text-6xl font-700 tracking-tighter text-white leading-[1.02]"
          {...fadeUp(0, { duration: 0.8 })}
        >
          YOUR ACCESS POINT TO<br />
          <span className="bg-gradient-to-r from-[#00D4FF] to-[#00E676] bg-clip-text text-transparent">THE BIOHACKER ECONOMY.</span>
        </motion.h2>

        <motion.p
          className="mt-10 max-w-2xl text-base sm:text-lg text-dim font-light leading-relaxed"
          {...fadeUp(0.1, { y: 20, duration: 0.8 })}
        >
          One membership connects you to a growing ecosystem of research, community, resources,
          rewards, preferred pricing and exclusive opportunities built around one objective:
        </motion.p>

        <motion.div
          className="mt-8 font-display text-2xl sm:text-4xl font-700 tracking-tight text-white"
          {...fadeIn(0.2)}
        >
          OPTIMIZE EVERYTHING.
        </motion.div>
      </div>
    </section>
  );
};
